import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../stores/store';

const selectNotificationList = (state: RootState) => state.notifications.items;
export const selectUnreadNotificationsCount = createSelector(
    [selectNotificationList],
    (notifications) => notifications.filter((n) => !n.isRead).length
);